/**
 * Format a carbon intensity number to 3dp.
 *
 * - Does not currently take a language and so will use browser defaults.
 * - If the value is below 0.0005, it will return '<0.001'.
 */

export default function formatCarbonIntensity(intensity?: number | null): string {
  const formatted = (intensity || 0).toLocaleString(undefined, {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });
  if (intensity && parseFloat(formatted) === 0) {
    return '<0.001';
  }
  return formatted;
}
